import { TDColor } from '@src/slide/domain/ui-model/element-modeles/property/color/td-color';
import { IPatternFillStyle } from '@src/slide/domain/ui-model/element-modeles/property/fill/fill.interface';
import { DeltaOf, ICTPatternFillProperties, STPresetPatternVal } from '@tencent/slide-sdk-model';
import lowerFirst from 'lodash/lowerFirst';
import { DeepPartial, DeepReadonly } from 'ts-essentials';
import _set from 'lodash/set';
import { colorStrToColorDmlA } from '@src/slide/infrastructure/module/independent/color/transform';
import { alphaToEmu } from '@src/slide/infrastructure/module/independent/unit';
import {
    ColorConverter,
} from '@src/slide/domain/ui-model/converter/node-property/module-property/color/color-converter';

export class PatternFillConverter {
    /**
     * 数据3.0转换接口
     * @param sdkData
     */
    public static convertPartialDataFromSdkToUi(sdkData: DeepReadonly<
        DeepPartial<ICTPatternFillProperties>>): IPatternFillStyle {
        return {
            preset: sdkData.prst ? lowerFirst(STPresetPatternVal[sdkData.prst]) : '',
            // @ts-ignore
            fgColor: sdkData.fgClr && ColorConverter.convertPartialDataFromSdkToUi(sdkData.fgClr).toPropValue(),
            // @ts-ignore
            bgColor: sdkData.bgClr && ColorConverter.convertPartialDataFromSdkToUi(sdkData.bgClr).toPropValue(),
        };
    }

    public static convertPartialDataFromUiToSdk(uiData: DeepPartial<IPatternFillStyle>):
    DeltaOf<ICTPatternFillProperties> {
        const toSdkData: DeltaOf<ICTPatternFillProperties> = {};
        if (uiData.preset !== undefined) {
            toSdkData.prst = STPresetPatternVal[uiData.preset];
        }
        if (uiData.fgColor?.color !== undefined) {
            const color = uiData.fgColor?.color;
            if (color?.colorValue) {
                // _set(toSdkData, 'fgClr', colorStrToColorDmlA(uiData.fgColor?.color?.colorValue));
                const egChoices = {};
                ColorConverter.convertPartialDataFromUiToSdk(color, egChoices);
                _set(toSdkData, 'fgClr', egChoices);
            }
        }
        if (uiData.bgColor?.color !== undefined) {
            const color = uiData.bgColor?.color;
            if (color?.colorValue) {
                // _set(toSdkData, 'bgClr', colorStrToColorDmlA(color?.colorValue));
                const egChoices = {};
                ColorConverter.convertPartialDataFromUiToSdk(color, egChoices);
                _set(toSdkData, 'bgClr', egChoices);
            }
        }
        return toSdkData;
    }
}
